import { SubscriptionModel } from 'app/modules/contract/model/subscription.model';

export const initialState = {
  isReady: false,
  loading: false,
  updated: false,
  redirect: false,
  subscriptionList: [],
  subscriptionModel: new SubscriptionModel(),
  page: 1,
  listImpaye: [],
  respondingSubscriptionBN: null,
  subsByNumberLoading: false,
  productOffreLoading: false,
  contractuelDocumentsLoading: false,
  listImpyeLoading: false,
};

export type ContractState = Readonly<typeof initialState>;
